import React from 'react';
import Modal from 'react-modal';

const ModalComponent = ({ isOpen, onRequestClose, children }) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      style={{
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        },
        content: {
          position: 'relative',
          top: 'auto',
          left: 'auto',
          right: 'auto',
          bottom: 'auto',
          transform: 'none',
          maxWidth: '90%',
          minWidth: '700px',
          maxHeight: '90vh',
          minHeight: 'fit-content',
          padding: '30px',
          border: 'none',
          borderRadius: '10px',
          boxShadow: '0 0 20px rgba(0, 0, 0, 0.2)',
          background: '#fff',
          overflow: 'auto'
        },
      }}
    >
      {children}
    </Modal>
  );
};

export default ModalComponent;